import { createEventsForTopicSelector, getEventFilterCount } from "domains/events/selectors";
import { createInitiativesForTopicSelector, getInitiativesFilterCount } from "domains/initiatives/selectors";
import { createInteractiveDataForTopicSelector, getIsKnowledgeDataFiltered } from "domains/knowledgeData/selectors";
import { createPublicationsForTopicSelector, getIsPublicationFiltered } from "domains/publication/selectors";
import { createStakeholdersForTopicSelector, getIsStakeholdersFiltered } from "domains/stakeholders/selectors";
import { createVideosForTopicSelector, getIsVideosFiltered } from "domains/videos/selectors";
import {
  getCanAccessTopicEvents,
  getCanAccessTopicInitiatives,
  getCanAccessTopicStakeholders,
} from "entities/permissions/selectors";
import type { RootState } from "types/redux";

export const getAreThereKnowledgeItems = (id: string) => (state: RootState) => {
  if (createPublicationsForTopicSelector(id)(state)?.data.length) return true;
  if (createVideosForTopicSelector(id)(state)?.data.length) return true;
  if (createInteractiveDataForTopicSelector(id)(state)?.data.length) return true;
  if (getCanAccessTopicEvents(state) && createEventsForTopicSelector(id)(state)?.data.length) return true;
  if (getCanAccessTopicInitiatives(state) && createInitiativesForTopicSelector(id)(state)?.data.length) return true;
  if (getCanAccessTopicStakeholders(state) && createStakeholdersForTopicSelector(id)(state)?.data.length) return true;
  return false;
};

export const getAreThereKnowledgeItemsPending = (id: string) => (state: RootState) => {
  if (createPublicationsForTopicSelector(id)(state)?.isFetching) return true;
  if (createEventsForTopicSelector(id)(state)?.isFetching) return true;
  if (createInteractiveDataForTopicSelector(id)(state)?.isFetching) return true;
  if (getCanAccessTopicEvents(state) && createEventsForTopicSelector(id)(state)?.isFetching) return true;
  if (getCanAccessTopicInitiatives(state) && createInitiativesForTopicSelector(id)(state)?.isFetching) return true;
  if (getCanAccessTopicStakeholders(state) && createStakeholdersForTopicSelector(id)(state)?.isFetching) return true;
  return false;
};

export const getAreThereKnowledgeItemFilters = (state: RootState) => {
  if (getIsPublicationFiltered(state)) return true;
  if (getIsVideosFiltered(state)) return true;
  if (getIsKnowledgeDataFiltered(state)) return true;
  if (getCanAccessTopicEvents(state) && getEventFilterCount(state)) return true;
  if (getCanAccessTopicInitiatives(state) && getInitiativesFilterCount(state)) return true;
  if (getCanAccessTopicStakeholders(state) && getIsStakeholdersFiltered(state)) return true;
  return false;
};
